<div id="Home_section">
  <div class="carousel-container">
    <div class="carousel-slide">
      <img
        [src]="slides[currentSlide].image"
        [alt]="slides[currentSlide].alt"
        class="carousel-image current"
        [class.fade-out]="isAnimating"
      />
      <img
        [src]="slides[nextSlideIndex].image"
        [alt]="slides[nextSlideIndex].alt"
        class="carousel-image next"
        [class.fade-in]="isAnimating"
      />
    </div>

    <button
      *ngIf="slides.length > 1"
      class="carousel-btn prev"
      (click)="prevSlide()"
    >
      <i class="fas fa-chevron-left"></i>
    </button>
    <button
      *ngIf="slides.length > 1"
      class="carousel-btn next"
      (click)="nextSlide()"
    >
      <i class="fas fa-chevron-right"></i>
    </button>

    <div class="carousel-indicators" *ngIf="slides.length > 1">
      <span
        *ngFor="let slide of slides; let i = index"
        class="indicator"
        [class.active]="i === currentSlide"
        (click)="goToSlide(i)"
      >
      </span>
    </div>
  </div>

  <div class="home">
    <div class="container">
      <div
        class="welcome-note"
        *ngIf="welcomeIsHtml || welcomeParagraphs.length > 0"
      >
        <h2>Welcome</h2>
        <div *ngIf="welcomeIsHtml" [innerHTML]="welcomeHtml"></div>
        <ng-container *ngIf="!welcomeIsHtml">
          <p *ngFor="let para of welcomeParagraphs">{{ para }}</p>
        </ng-container>
      </div>

      <div
        class="features-box"
        *ngIf="
          isFeatureVisible(0) || isFeatureVisible(1) || isFeatureVisible(2)
        "
      >
        <h3>Our Features</h3>
        <div class="pathway-container">
          <div class="pathway-line"></div>
          <div class="features-row">
            <ng-container *ngIf="landingFeatures[0].enabled">
              <div class="feature" *appPortalFeature="'registration'">
                <div class="step-badge">
                  <span class="step-number">1</span>
                  <div class="step-icon">
                    <i class="fas fa-user-plus"></i>
                  </div>
                </div>
                <div class="feature-content">
                  <h3>{{ landingFeatures[0].title }}</h3>
                  <small>{{ landingFeatures[0].content }}</small>
                  <a
                    href="/vendor-registration"
                    type="button"
                    class="feature-link post-tag"
                  >
                    <i class="fas fa-user-plus"></i>
                    {{ landingFeatures[0].buttonText }}
                  </a>
                </div>
              </div>
            </ng-container>

            <div
              class="pathway-connector"
              *ngIf="
                isFeatureVisible(0) &&
                (isFeatureVisible(1) || isFeatureVisible(2))
              "
            >
              <div class="connector-line"></div>
              <div class="connector-arrow">
                <i class="fas fa-arrow-down"></i>
              </div>
            </div>

            <ng-container *ngIf="landingFeatures[1].enabled">
              <div class="feature" *appPortalFeature="'signup'">
                <div class="step-badge">
                  <span class="step-number">2</span>
                  <div class="step-icon">
                    <i class="fas fa-cog"></i>
                  </div>
                </div>
                <div class="feature-content">
                  <h3>{{ landingFeatures[1].title }}</h3>
                  <small>{{ landingFeatures[1].content }}</small>
                  <a href="/vendor-sign-up" class="feature-link">
                    <i class="fas fa-cog"></i>
                    {{ landingFeatures[1].buttonText }}
                  </a>
                </div>
              </div>
            </ng-container>

            <div
              class="pathway-connector"
              *ngIf="isFeatureVisible(1) && isFeatureVisible(2)"
            >
              <div class="connector-line"></div>
              <div class="connector-arrow">
                <i class="fas fa-arrow-down"></i>
              </div>
            </div>

            <ng-container *ngIf="landingFeatures[2].enabled">
              <div class="feature" *appPortalFeature="'invoice'">
                <div class="step-badge">
                  <span class="step-number">3</span>
                  <div class="step-icon">
                    <i class="fas fa-file-invoice-dollar"></i>
                  </div>
                </div>
                <div class="feature-content">
                  <h3>{{ landingFeatures[2].title }}</h3>
                  <small>{{ landingFeatures[2].content }}</small>
                  <a
                    href="/vendor-invoice"
                    class="feature-link"
                    *appPortalButton
                  >
                    <i class="fas fa-file-invoice-dollar"></i>
                    {{ landingFeatures[2].buttonText }}
                  </a>
                  <a
                    href="/login"
                    *appPortalLoginRequired
                    class="feature-link"
                  >
                    <i class="fas fa-lock"></i>
                    {{ landingFeatures[2].buttonText }}
                  </a>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-registration-help *appPortalFeature="'guestChat'"></app-registration-help>
